import { render, staticRenderFns } from "./taskFullinfo.vue?vue&type=template&id=5457f777&scoped=true"
import script from "./taskFullinfo.vue?vue&type=script&lang=js"
export * from "./taskFullinfo.vue?vue&type=script&lang=js"
import style0 from "./taskFullinfo.vue?vue&type=style&index=0&id=5457f777&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5457f777",
  null
  
)

export default component.exports